import PropTypes from 'prop-types';
import './Avatar.css';

export default function Avatar({
    src,
    alt,
    name,
    size = 'md',
    className = ''
}) {
    const getInitials = (name) => {
        if (!name) return '?';
        return name
            .split(' ')
            .map((n) => n.charAt(0))
            .slice(0, 2)
            .join('')
            .toUpperCase();
    };

    const getColorFromName = (name) => {
        const colors = [
            '#2563eb', '#7c3aed', '#db2777', '#dc2626',
            '#ea580c', '#16a34a', '#0891b2', '#4f46e5'
        ];
        if (!name) return colors[0];
        const index = name.charCodeAt(0) % colors.length;
        return colors[index];
    };

    return (
        <div
            className={`avatar avatar-${size} ${className}`}
            style={{ backgroundColor: !src ? getColorFromName(name) : undefined }}
        >
            {src ? (
                <img src={src} alt={alt || name} className="avatar-image" />
            ) : (
                <span className="avatar-initials">{getInitials(name)}</span>
            )}
        </div>
    );
}

Avatar.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    className: PropTypes.string
};
